export const CONTACT = {
  company: "PT. Luminara Global Persada",
  email: "luminaraglobalpersada@gmail.com",
  email2: "mitralugo@luminaraglobalpersada.online",
  phoneDisplay: "0817-7091-4965",
  phoneIntl: "+6281770914965",
  waLink: "https://wa.me/6281770914965?text=Halo%20PT.%20Luminara%20Global%20Persada%2C%20saya%20ingin%20berkonsultasi%20mengenai%20kebutuhan%20proyek%20kami.",
  address: "Jalan Merdeka No. 47, Kelurahan Abadijaya, Kecamatan Sukmajaya, Kota Depok, Jawa Barat 16417",
  hours: [
    { day: "Senin – Jumat", time: "08.00 – 17.00 WIB" },
    { day: "Sabtu", time: "08.00 – 12.00 WIB" },
    { day: "Minggu & Hari Libur Nasional", time: "Tutup" },
  ],
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1690944851207-3f288c8fcd0b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBza3lzY3JhcGVyJTIwYXJjaGl0ZWN0dXJlJTIwZ2xhc3N8ZW58MHx8fHwxNzg3NTUyOTEzfDA&ixlib=rb-4.1.0&q=85",
  glassFacade: "https://images.pexels.com/photos/37320179/pexels-photo-37320179.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  luxuryInterior: "https://images.pexels.com/photos/20418771/pexels-photo-20418771.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  architectureInterior: "https://images.unsplash.com/photo-1611048267451-e6ed903d4a38?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBpbnRlcmlvciUyMGxpdmluZyUyMHJvb218ZW58MHx8fHwxNzg3NTUyOTEzfDA&ixlib=rb-4.1.0&q=85",
  engineersOutdoor: "https://images.pexels.com/photos/8961133/pexels-photo-8961133.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  architectsBlueprint: "https://images.unsplash.com/photo-1774600166834-175d06febcd4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwzfHxlbmdpbmVlcnMlMjBsb29raW5nJTIwYXQlMjBibHVlcHJpbnR8ZW58MHx8fHwxNzg3NTUyOTEzfDA&ixlib=rb-4.1.0&q=85",
  construction: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?auto=format&fit=crop&q=80&w=1200",
  officeBuilding: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&q=80&w=1200",
  blueprint: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&q=80&w=1200",
};

export const DIRECTORS = [
  {
    name: "Rasyid Hadi Munandar",
    role: "Direktur Utama",
    desc: "Memimpin arah strategis perusahaan, menjalin kemitraan utama, serta memastikan setiap keputusan sejalan dengan visi dan nilai PT. Luminara Global Persada.",
    photo: "/assets/direksi/rasyid-hadi-munandar.jpg",
  },
  {
    name: "Iir Yusnita",
    role: "Direktur Keuangan",
    desc: "Mengelola keuangan, perencanaan anggaran proyek, serta pengendalian biaya agar setiap pekerjaan berjalan efisien dan akuntabel.",
    photo: "/assets/direksi/iir-yusnita.jpg",
  },
  {
    name: "Risky Setya Hadi",
    role: "Direktur Operasional",
    desc: "Mengawal pelaksanaan proyek dari perencanaan hingga serah terima, memastikan mutu, jadwal, dan keselamatan kerja terjaga.",
    photo: "/assets/direksi/risky-setya-hadi.jpg",
  },
  {
    name: "Rifqi Rivaldo",
    role: "Direktur Marketing",
    desc: "Mengembangkan relasi klien dan mitra, menyusun strategi pemasaran, serta menjaga kepercayaan pasar terhadap perusahaan.",
    photo: "/assets/direksi/rifqi-rivaldo.jpg",
  },
  {
    name: "M. Rizky Fiqi",
    role: "Kepala Pengawas Lapangan",
    desc: "Mengawasi pelaksanaan pekerjaan di lokasi proyek, mengendalikan mutu teknis, dan memastikan standar keselamatan diterapkan.",
    photo: "/assets/direksi/m-rizky-fiqi.jpg",
  },
];

export const SERVICE_GROUPS = [
  {
    id: "konstruksi-gedung",
    title: "Konstruksi Gedung",
    en: "Building Construction",
    desc: "Pembangunan gedung konvensional untuk berbagai fungsi, dari hunian hingga fasilitas pendidikan, dengan perencanaan matang dan mutu terjaga.",
    items: [
      { kbli: "41011", name: "Konstruksi Gedung Hunian", desc: "Pembangunan rumah tinggal dan gedung hunian yang kokoh, fungsional, dan nyaman dihuni." },
      { kbli: "41012", name: "Konstruksi Gedung Perkantoran", desc: "Pembangunan gedung kantor yang mendukung produktivitas dengan tata ruang efisien dan representatif." },
      { kbli: "41013", name: "Konstruksi Gedung Industri", desc: "Pembangunan fasilitas industri seperti pabrik dan gudang sesuai standar teknis operasional." },
      { kbli: "41014", name: "Konstruksi Gedung Perbelanjaan", desc: "Pembangunan pusat perbelanjaan dan ruang komersial dengan memperhatikan sirkulasi dan estetika." },
      { kbli: "41016", name: "Konstruksi Gedung Pendidikan", desc: "Pembangunan sekolah dan fasilitas pendidikan yang aman, sehat, dan mendukung kegiatan belajar." },
      { kbli: "41019", name: "Konstruksi Gedung Lainnya", desc: "Pembangunan gedung fungsi khusus lainnya sesuai kebutuhan dan spesifikasi klien." },
    ],
  },
  {
    id: "konstruksi-sipil-infrastruktur",
    title: "Konstruksi Sipil & Infrastruktur",
    en: "Civil & Infrastructure Works",
    desc: "Pekerjaan sipil dan infrastruktur yang menunjang konektivitas serta pengelolaan lingkungan kawasan.",
    items: [
      { kbli: "42101", name: "Konstruksi Jalan pada Permukaan Tanah", desc: "Pembangunan dan peningkatan jalan dengan perencanaan struktur perkerasan yang tepat." },
      { kbli: "42102", name: "Konstruksi Jembatan, Jalan Layang, Fly Over & Underpass", desc: "Pembangunan bangunan sipil penunjang lalu lintas dengan standar keamanan struktur yang ketat." },
      { kbli: "42201", name: "Konstruksi Jaringan Irigasi & Drainase", desc: "Pembangunan jaringan irigasi dan drainase untuk pengelolaan air kawasan yang berkelanjutan." },
    ],
  },
  {
    id: "finishing-interior",
    title: "Finishing & Interior",
    en: "Finishing & Interior Works",
    desc: "Pekerjaan penyelesaian bangunan yang menentukan kualitas akhir, kenyamanan, dan tampilan ruang.",
    items: [
      { kbli: "43301", name: "Pemasangan Kaca, Pintu, Kusen & Jendela", desc: "Pemasangan elemen bukaan bangunan dengan presisi dan material berkualitas." },
      { kbli: "43302", name: "Pengerjaan Lantai, Dinding & Plafon", desc: "Pengerjaan elemen interior bangunan dengan kerapian detail dan pilihan material yang tepat." },
      { kbli: "43309", name: "Penyelesaian Konstruksi Bangunan Lainnya", desc: "Pekerjaan penyelesaian akhir bangunan hingga siap digunakan sesuai spesifikasi." },
    ],
  },
  {
    id: "perdagangan-besar",
    title: "Perdagangan Besar",
    en: "Wholesale Trading",
    desc: "Layanan perdagangan besar dan pengadaan barang dengan jaringan pemasok yang andal dan tata kelola kontrak yang jelas.",
    items: [
      { kbli: "46100", name: "Perdagangan Besar atas Dasar Balas Jasa (Fee) atau Kontrak", desc: "Layanan perantara perdagangan dan pengadaan berbasis kontrak dengan pengelolaan profesional." },
      { kbli: "46206", name: "Perdagangan Besar Ikan & Biota Air Hidup", desc: "Penyediaan ikan dan biota air hidup dengan penanganan yang menjaga kualitas produk." },
      { kbli: "46324", name: "Perdagangan Besar Hasil Perikanan & Olahan Terkait", desc: "Distribusi hasil perikanan dan produk olahannya untuk kebutuhan pasar dan industri." },
      { kbli: "46511", name: "Perdagangan Besar Komputer & Perlengkapan", desc: "Pengadaan komputer dan perlengkapannya untuk kebutuhan korporat dan institusi." },
    ],
  },
  {
    id: "arsitektur-desain-lanskap",
    title: "Arsitektur, Desain Interior & Lanskap",
    en: "Architecture, Interior Design & Landscape",
    desc: "Layanan perancangan yang menyatukan fungsi, estetika, dan konteks lingkungan dalam setiap karya.",
    items: [
      { kbli: "71101", name: "Aktivitas Arsitektural", desc: "Perancangan arsitektur bangunan dari konsep hingga gambar kerja yang terukur dan dapat dieksekusi." },
      { kbli: "74191", name: "Aktivitas Desain Interior", desc: "Perancangan interior yang fungsional, estetis, dan sesuai karakter penggunanya." },
      { kbli: "81300", name: "Aktivitas Jasa Lanskap", desc: "Perencanaan dan penataan lanskap kawasan yang harmonis dengan bangunan dan lingkungannya." },
    ],
  },
];

export const KEUNGGULAN = [
  { icon: "Users", title: "Tim Profesional & Berpengalaman", desc: "Didukung tenaga ahli dan praktisi lapangan yang memahami standar teknis setiap jenis pekerjaan." },
  { icon: "Layers", title: "Solusi Terintegrasi", desc: "Layanan menyeluruh dari perencanaan, pembangunan, hingga pengadaan dalam satu koordinasi." },
  { icon: "Award", title: "Standar Mutu Tinggi", desc: "Setiap pekerjaan dikendalikan melalui pemeriksaan mutu berlapis sesuai spesifikasi yang disepakati." },
  { icon: "Clock", title: "Komitmen Ketepatan Waktu", desc: "Jadwal pelaksanaan disusun realistis dan dipantau secara disiplin hingga serah terima." },
  { icon: "Headset", title: "Dukungan Teknis & Konsultasi", desc: "Klien mendapatkan pendampingan teknis dan ruang konsultasi sejak tahap awal perencanaan." },
  { icon: "HeartHandshake", title: "Fokus pada Kepuasan Pelanggan", desc: "Kami mendengarkan kebutuhan klien dan menjaga komunikasi yang transparan di setiap tahap." },
];

export const PROSES_KERJA = [
  { title: "Konsultasi Awal", desc: "Memahami kebutuhan, tujuan, dan ekspektasi klien melalui diskusi awal yang terarah." },
  { title: "Survei & Analisis Kebutuhan", desc: "Melakukan survei lokasi dan kajian teknis sebagai dasar perencanaan yang akurat." },
  { title: "Perencanaan & Penawaran", desc: "Menyusun rancangan, rencana anggaran biaya, dan jadwal kerja dalam penawaran yang transparan." },
  { title: "Pelaksanaan Pekerjaan", desc: "Mengeksekusi pekerjaan sesuai rencana dengan pengawasan mutu dan keselamatan kerja." },
  { title: "Quality Control", desc: "Melakukan pemeriksaan berkala dan uji mutu untuk memastikan hasil sesuai spesifikasi." },
  { title: "Serah Terima & Layanan Purna Jual", desc: "Menyerahkan hasil pekerjaan secara resmi disertai dukungan layanan purna jual." },
];

export const PROYEK = [
  {
    name: "Pembangunan Gedung Perkantoran",
    type: "Konstruksi Gedung Perkantoran (41012)",
    location: "Kota Depok, Jawa Barat",
    result: "Gedung kantor empat lantai diselesaikan sesuai jadwal dengan mutu struktur dan finishing terkendali.",
    image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&q=80&w=1200",
  },
  {
    name: "Renovasi Interior Ruang Komersial",
    type: "Desain Interior & Finishing (74191 / 43302)",
    location: "Jakarta Selatan, DKI Jakarta",
    result: "Transformasi ruang komersial menjadi area kerja modern yang fungsional dan representatif.",
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&q=80&w=1200",
  },
  {
    name: "Pekerjaan Jalan & Drainase Kawasan",
    type: "Konstruksi Sipil (42101 / 42201)",
    location: "Kabupaten Bogor, Jawa Barat",
    result: "Peningkatan akses jalan dan jaringan drainase kawasan untuk mengurangi genangan musiman.",
    image: "https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?auto=format&fit=crop&q=80&w=1200",
  },
  {
    name: "Desain Arsitektur Hunian Modern",
    type: "Aktivitas Arsitektural (71101)",
    location: "Kota Bekasi, Jawa Barat",
    result: "Perancangan hunian modern yang memaksimalkan pencahayaan alami dan efisiensi tata ruang.",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&q=80&w=1200",
  },
  {
    name: "Penataan Lanskap Area Publik",
    type: "Jasa Lanskap (81300)",
    location: "Kota Depok, Jawa Barat",
    result: "Penataan ruang terbuka hijau yang harmonis dengan lingkungan sekitar dan mudah dirawat.",
    image: "https://images.unsplash.com/photo-1558904541-efa843a96f01?auto=format&fit=crop&q=80&w=1200",
  },
  {
    name: "Finishing Gedung Pendidikan",
    type: "Finishing & Interior (43302 / 43309)",
    location: "Jakarta Timur, DKI Jakarta",
    result: "Penyelesaian lantai, dinding, dan plafon fasilitas pendidikan dengan standar kenyamanan belajar.",
    image: "https://images.unsplash.com/photo-1562774053-701939374585?auto=format&fit=crop&q=80&w=1200",
  },
];

export const FAQ = [
  {
    q: "Apa saja bidang usaha PT. Luminara Global Persada?",
    a: "PT. Luminara Global Persada bergerak di lima kategori utama: konstruksi gedung (hunian, perkantoran, industri, perbelanjaan, pendidikan, dan gedung lainnya), konstruksi sipil dan infrastruktur (jalan, jembatan, fly over, underpass, irigasi, dan drainase), finishing dan interior, perdagangan besar, serta arsitektur, desain interior, dan jasa lanskap.",
  },
  {
    q: "Apakah PT. Luminara Global Persada melayani proyek konstruksi skala kecil dan besar?",
    a: "Ya. Kami melayani pekerjaan mulai dari renovasi dan finishing skala kecil hingga pembangunan gedung dan infrastruktur skala besar. Setiap proyek dikelola dengan standar perencanaan dan pengendalian mutu yang sama.",
  },
  {
    q: "Bagaimana cara menghubungi PT. Luminara Global Persada?",
    a: "Anda dapat menghubungi kami melalui email luminaraglobalpersada@gmail.com, telepon/WhatsApp 0817-7091-4965, atau mengisi formulir kontak di halaman ini. Tim kami akan merespons pada jam operasional Senin–Jumat 08.00–17.00 WIB dan Sabtu 08.00–12.00 WIB.",
  },
  {
    q: "Apakah tersedia layanan arsitektur dan desain interior?",
    a: "Tersedia. Kami menyediakan aktivitas arsitektural (KBLI 71101) dan desain interior (KBLI 74191), mulai dari konsep desain, gambar kerja, hingga pendampingan saat pelaksanaan pembangunan.",
  },
  {
    q: "Apakah perusahaan melayani kebutuhan perdagangan besar dan pengadaan?",
    a: "Ya. Melalui lini perdagangan besar, kami melayani pengadaan berbasis kontrak (KBLI 46100), perdagangan hasil perikanan (46206 dan 46324), serta komputer dan perlengkapannya (46511) untuk kebutuhan korporat dan institusi.",
  },
];

export const VISI = "Menjadi perusahaan yang unggul, terpercaya, dan berdaya saing tinggi di tingkat nasional dalam bidang konstruksi, arsitektur, interior, lanskap, dan perdagangan.";

export const MISI = [
  "Menghasilkan pekerjaan berkualitas tinggi yang memenuhi standar mutu dan spesifikasi teknis yang disepakati.",
  "Menempatkan kepuasan klien sebagai prioritas utama dalam setiap layanan dan proyek.",
  "Menjamin ketepatan waktu pelaksanaan melalui perencanaan dan pengendalian kerja yang disiplin.",
  "Mengembangkan inovasi dan solusi terpadu di bidang konstruksi, desain, dan perdagangan.",
  "Menjunjung tinggi integritas, transparansi, dan etika bisnis dalam setiap hubungan kerja sama.",
  "Menerapkan praktik kerja yang aman, efisien, dan berkelanjutan bagi lingkungan dan masyarakat.",
];
